import { useEffect } from 'react';

interface UseOutsideClickOptions {
  ref: React.RefObject<HTMLElement | null>;
  enabled?: boolean;
  handler: (event: MouseEvent | TouchEvent) => void;
}

// Chakra exports no useOutsideClick hook; this implements the same signature.
export const useOutsideClick = ({ ref, enabled = true, handler }: UseOutsideClickOptions) => {
  useEffect(() => {
    if (!enabled) return;

    const listener = (event: MouseEvent | TouchEvent) => {
      const el = ref.current;
      if (!el || el.contains(event.target as Node)) return;
      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, enabled, handler]);
};
